import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'hooks/store';
import {
  cleanLocationsAction,
  getClientLocationsListAction,
  locationRemoteTotalSelector,
} from 'state/slices/clients';
import {
  Route,
  Switch,
  useParams,
  useRouteMatch,
} from 'react-router';
import { ClientLocation, PaginationData } from 'constants/interface';
import { usePagination } from 'hooks/pagination';
import { ROUTES } from 'constants/routes';

import {
  ClientDetailsPage,
  LocationDetailsPage,
} from './pages';

interface ClientDetailsViewRouteParams {
  clientId: string
}

interface ClientDetailViewPageProps {
  onUpdateFinish?(): void
}

const ClientDetailViewPage = ({
  onUpdateFinish,
}: ClientDetailViewPageProps): JSX.Element => {
  const dispatch = useDispatch();
  const { clientId } = useParams<ClientDetailsViewRouteParams>();
  const { path } = useRouteMatch();
  const remoteTotal = useSelector(locationRemoteTotalSelector);

  const remoteFetch = (
    paginationData: PaginationData,
  ) => {
    dispatch(getClientLocationsListAction({
      clientId,
      paginationData,
    }));
  };
  const pagination = usePagination<ClientLocation>(
    remoteFetch,
    {
      defaultPageSize: 5,
    },
  );

  useEffect(() => {
    dispatch(cleanLocationsAction());
  }, []);

  useEffect(() => {
    pagination.updateTotal(remoteTotal);
  }, [remoteTotal]);

  return (
    <Switch>
      <Route
        path={`${
          path
        }${
          ROUTES.dashboard.clients.detail.locations.root
        }${
          ROUTES.dashboard.clients.detail.locations.detail.root
        }`}
        render={() => <LocationDetailsPage onUpdateFinish={pagination.fetch} />}
      />
      <Route
        path={`${path}`}
        render={() => (
          <ClientDetailsPage
            locationPageData={pagination.getInternal()}
            onLocationTableChange={pagination.onTableChange}
            refreshLocations={() => pagination.fetch()}
            onUpdateFinish={onUpdateFinish}
          />
        )}
      />
    </Switch>
  );
};

const defaultProps: ClientDetailViewPageProps = {
  onUpdateFinish: () => {},
};

ClientDetailViewPage.defaultProps = defaultProps;

export default ClientDetailViewPage;
